"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { Chatbot } from "@/types/chatbot";
type ChatHeaderProps = {
  currentThreadTitle: string | null;
  onShowInfo?: () => void;
  hasThread?: boolean;
  /** The active chatbot for this thread */
  activeChatbot?: Chatbot | null;
  /** Called when edit chatbot button is clicked */
  onEditChatbot?: () => void;
  /** Whether chatbot settings are currently being edited */
  isEditingChatbot?: boolean;
  /** Called when default chatbot edit button is clicked (no chatbot assigned) */
  onEditDefaultChatbot?: () => void;
};
const ChatHeader: React.FC<ChatHeaderProps> = t0 => {
  const $ = _c(21);
  const {
    currentThreadTitle,
    hasThread: t1,
    activeChatbot,
    onEditChatbot,
    isEditingChatbot: t2,
    onEditDefaultChatbot
  } = t0;
  t1 === undefined ? false : t1;
  const isEditingChatbot = t2 === undefined ? false : t2;
  const provider = activeChatbot?.config?.model?.provider || "ai";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      openai: "bg-green-500",
      claude: "bg-orange-500",
      grok: "bg-blue-500",
      gemini: "bg-purple-500"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const providerColors = t3;
  const dotColor = providerColors[provider] || "bg-foreground/50";
  const t4 = currentThreadTitle || "Untitled";
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-foreground/50">.thread</span>;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== t4) {
    t6 = <span className="text-sm font-medium text-foreground">{t4}{t5}</span>;
    $[2] = t4;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="h-4 w-px bg-white/30" />;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = `h-2 w-2 rounded-full ${activeChatbot ? dotColor : "bg-foreground/30"}`;
  let t9;
  if ($[5] !== t8) {
    t9 = <span className={t8} />;
    $[5] = t8;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== activeChatbot) {
    t10 = <span className="text-sm text-foreground">{activeChatbot ? <>{activeChatbot.name}<span className="text-foreground/50">.chatbot</span></> : <><span className="text-foreground/60">default</span><span className="text-foreground/30">.chatbot</span></>}</span>;
    $[7] = activeChatbot;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== activeChatbot || $[10] !== isEditingChatbot || $[11] !== onEditChatbot || $[12] !== onEditDefaultChatbot) {
    t11 = (activeChatbot ? onEditChatbot : onEditDefaultChatbot) && <button onClick={activeChatbot ? onEditChatbot : onEditDefaultChatbot} disabled={isEditingChatbot} className={`ml-1 p-1 rounded transition-colors ${isEditingChatbot ? "text-sky bg-sky/20 cursor-not-allowed" : "text-foreground/40 hover:text-foreground hover:bg-white/40"}`} title={isEditingChatbot ? "Currently editing..." : activeChatbot ? "Edit chatbot settings" : "Customize default settings"}><svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg></button>;
    $[9] = activeChatbot;
    $[10] = isEditingChatbot;
    $[11] = onEditChatbot;
    $[12] = onEditDefaultChatbot;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t9) {
    t12 = <>{t7}<div className="flex items-center gap-1.5">{t9}{t10}{t11}</div></>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t6) {
    t13 = <header className="flex items-center justify-between border-b border-white/30 px-4 py-3"><div className="flex items-center gap-4">{t6}{t12}</div></header>;
    $[18] = t12;
    $[19] = t6;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};
export default ChatHeader;